module.exports = __webpack_public_path__ + "ed0d4226cbb6bee8a57f485d6bb0eae6.png";